import React, {Component, PropTypes} from 'react';
import Print from './print';
import Download from './download';
import Share from './share';
import Settings from './settings';

export default class Footer extends Component {
    static propTypes = {
        loading: PropTypes.bool.isRequired,
        share: PropTypes.bool.isRequired,
        print: PropTypes.bool.isRequired,
        download: PropTypes.bool.isRequired,
        hideLogo: PropTypes.bool,
        disableLink: PropTypes.bool,
        clientLogoImage: PropTypes.string,
        clientLogoHref: PropTypes.string,
        sponsorLogoImage: PropTypes.string,
        sponsorLogoHref: PropTypes.string,
    };

    shouldComponentUpdate(nextProps) {
        return nextProps.loading !== this.props.loading
            || nextProps.share !== this.props.share
            || nextProps.print !== this.props.print
            || nextProps.download !== this.props.download;
    }

    renderCieloLogo() {
        const content = <span>Cielo24</span>;
        if (this.props.disableLink) return <div className='cielo24-vwrap-cielo-logo'>{content}</div>;
        return (
            <a
                className='cielo24-vwrap-cielo-logo'
                href='https://cielo24.com/'
                target='_blank'
                rel='noopener noreferrer'
            >
                {content}
            </a>
        );
    }

    renderExternalLogo(image, link) {
        const LogoComponent = props => (
            link
                ? <a {...props} href={link} target='_blank' rel='noopener noreferrer' />
                : <div {...props} />
        );

        return <LogoComponent className='cielo24-vwrap-external-logo'><img src={image} /></LogoComponent>;
    }

    render() {
        const {share, print, download, loading} = this.props;
        const {hideLogo, clientLogoImage, clientLogoHref, sponsorLogoImage, sponsorLogoHref} = this.props;

        return (
            <div className='cielo24-vwrap-footer'>
                <div className='cielo24-vwrap-logos'>
                    {clientLogoImage && this.renderExternalLogo(clientLogoImage, clientLogoHref)}
                    {sponsorLogoImage && this.renderExternalLogo(sponsorLogoImage, sponsorLogoHref)}
                    {!hideLogo && this.renderCieloLogo()}
                </div>
                {!loading && (
                    <ul className='cielo24-vwrap-actions'>
                        <li>{print && <Print />}</li>
                        <li>{download && <Download />}</li>
                        <li>{share && <Share />}</li>
                        <li><Settings /></li>
                    </ul>
                )}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./scripts/components/footer/footer.js